/**
 * Hub appKey → lucide-react Icon (v0-style).
 * Used by AppCard when no icon prop is passed.
 *
 * Auflösung: Katalog `iconKey` (catalog.static.js) → Lucide-Komponente.
 * - minigames: iconKey null im Katalog → kein Icon (wie zuvor).
 * - tennis-live: iconKey "globe" → Globe (wie zuvor).
 * Unbekannte iconKey-Strings → null (defensiv, kein sichtbarer Wechsel zum früheren „nicht in Map“).
 */
import {
  Repeat,
  GraduationCap,
  Trophy,
  Swords,
  Globe,
  Building2,
  CalendarDays,
  CalendarRange,
  Users,
  ClipboardList,
  BarChart3,
  Workflow,
} from "lucide-react";
import { getAppCatalogEntry } from "../../app-catalog/index.js";

/** Katalog-Feld `iconKey` → lucide (kebab-case wo nötig, wie im Katalog). */
const ICON_KEY_TO_COMPONENT = Object.freeze({
  repeat: Repeat,
  "graduation-cap": GraduationCap,
  trophy: Trophy,
  swords: Swords,
  globe: Globe,
  "building-2": Building2,
  "calendar-days": CalendarDays,
  "calendar-range": CalendarRange,
  users: Users,
  "clipboard-list": ClipboardList,
  "bar-chart-3": BarChart3,
  workflow: Workflow,
});

/**
 * @param {string} appKey
 * @returns {import('react').ComponentType<{ size?: number; strokeWidth?: number }> | null}
 */
export function getIconForApp(appKey) {
  if (!appKey || typeof appKey !== "string") return null;
  const k = appKey.toLowerCase().trim();
  const entry = getAppCatalogEntry(k);
  const iconKey = entry?.iconKey;
  if (iconKey == null || iconKey === "") return null;
  return ICON_KEY_TO_COMPONENT[iconKey] ?? null;
}
